///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2020 - 2022
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import React from "react";
import { useDispatch } from "react-redux";

import messages from "../helpers/messages";

import { filterActiveBids } from "../slices/activeBidsSlice";
import SearchBox from "./SearchBox";

const HomePageSearch = ({ user, value, cardView }) => {
  const dispatch = useDispatch();
  const updateSearchTerm = event => {
    dispatch(
      filterActiveBids({
        cardView,
        field: "searchTerm",
        value: event.target.value.trimLeft(),
        user
      })
    );
  };

  return (
    <form id="home-page-search" className="inline-block">
      <SearchBox
        id="home-search-input"
        onChange={updateSearchTerm}
        placeholder={messages.searchThisPage.defaultMessage}
        type="text"
        value={value}
        autoComplete="off"
      />
    </form>
  );
};

export default HomePageSearch;
